"use client";
import {
  Box,
  Button,
  GridProps,
  Heading,
  Text,
  ResponsiveValue,
  SimpleGrid,
  Stack,
} from "@chakra-ui/react";
import {Balancer} from "react-wrap-balancer";
import BgImage from "public/shared/darkBgCardbg.png";
import PageLayout from "@/layouts/pageLayout";
import {BUTTON_VARIANTS} from "@/theme/components/button";
import {useSectionHeadingVariant} from "@/theme/components/useSectionHeading";
import {TEXT_VARIANTS} from "@/theme/components/text";
import {scrollToElement} from "@/utils/scrollToElement";
import Card, {CardProps} from "../cardsList/card";

type Props = {
  columns?: ResponsiveValue<number>;
  spacing?: GridProps["gridGap"];
  title: string;
  desc?: string;
  list: CardProps[];
  button?: {
    label: string;
    link: string;
  };
  concText?: {
    label: string;
    text: string;
  };
};

const DarkBgCardsFrame = (props: Props) => {
  const {
    columns = {base: 1, sm: 1, md: 3},
    spacing = {base: 8, md: 16, "2xl": 24},
    title,
    desc,
    list,
    button,
    concText,
  } = props;
  const headingVariant = useSectionHeadingVariant();
  return (
    <Box backgroundImage={BgImage.src} backgroundSize="cover " py={20}>
      <PageLayout spacing={16} marginTop={0}>
        <Stack spacing={6}>
          {title && (
            <Heading as="h1" variant={headingVariant} textAlign={"center"} color="white">
              {title}
            </Heading>
          )}
          {desc && (
            <Balancer>
              <Text variant={TEXT_VARIANTS.LABEL1} textAlign={"center"} color="white">
                {desc}
              </Text>
            </Balancer>
          )}
        </Stack>
        <SimpleGrid columns={columns} spacing={spacing}>
          {list.map((item, index) => (
            <Card key={index} {...item} />
          ))}
        </SimpleGrid>
        {button && (
          <Button
            variant={BUTTON_VARIANTS.OUTLINE}
            onClick={() => scrollToElement(button.link, 120)}
            w="fit-content"
            alignSelf={"center"}
          >
            {button.label}
          </Button>
        )}
        {concText && (
          <Box>
            <Text
              as="span"
              variant={TEXT_VARIANTS.LABEL1}
              textAlign={"center"}
              fontWeight={600}
              color="white"
              textDecoration={"underline"}
            >
              {concText.label}
            </Text>{" "}
            <Text
              as="span"
              variant={TEXT_VARIANTS.LABEL1}
              textAlign={"center"}
              color="white"
            >
              : {concText.text}
            </Text>
          </Box>
        )}
      </PageLayout>
    </Box>
  );
};

export default DarkBgCardsFrame;
